import { render, staticRenderFns } from "./GraphicCarrousel.vue?vue&type=template&id=2955a3c3&scoped=true"
import script from "./GraphicCarrousel.vue?vue&type=script&lang=js"
export * from "./GraphicCarrousel.vue?vue&type=script&lang=js"
import style0 from "./GraphicCarrousel.vue?vue&type=style&index=0&id=2955a3c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2955a3c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCarousel,VCarouselItem,VImg})
